<template>
  <article>
    <div id="AUTH_CONFIRMATION" class="container-fixed offset-bottom-6">
      <VProgress class="offset-top-2 offset-bottom-2" :steps="steps" active="auth.confirmation" />
      <p class="offset-bottom-2 offset-top-2" v-html="$tc('auth.descriptionStep2', $route.params.msisdn)"></p>
      <transition name="fade" mode="out-in" appear>
        <VForm v-if="form" :form="form" @submit="onNext">
          <VInput name="otp" :label="$t('auth.otpLabel')" :hint="$t('errorcodes.WRONG_OTP')" required />

          <div class="offset-top-2 text-right">
            <transition name="fade" mode="out-in" appear>
              <div v-if="isOtpResendDisabled" class="notification notification-negative" role="alert">
                <div class="notification-left">
                  <div class="icon-frame">
                    <VSvgIcon name="information" variant="outlined" size="large" />
                  </div>
                </div>
                <div class="notification-content">
                  <div class="notification-heading offset-top-1">
                    {{ $t('errorcodes.OTP_RESEND_LIMIT_EXCEEDED') }}
                  </div>
                </div>
              </div>
            </transition>
            <transition name="fade" mode="out-in" appear>
              <VSpinner v-if="isBusy" slim class="pull-left" />
            </transition>
            <VButton
              type="button"
              class="offset-left-1 offset-bottom-1 btn-default"
              label="auth.otpResendButtonLabel"
              :disabled="isBusy || isOtpResendDisabled"
              @click="onResendOtp"
            />
            <VButton type="submit" class="offset-left-1 offset-bottom-1 btn-default btn-brand" label="auth.buttonLabelStep2" :disabled="isBusy" />
          </div>
        </VForm>
        <VSpinner v-else />
      </transition>
    </div>
  </article>
</template>

<script>
import VSpinner from '@/components/Spinner';
import TitleMixin from '@/mixins/title';
import AuthStepsMixin from '@/mixins/authSteps';
import OtpResendMixin from '@/mixins/otpResend';
import VForm from '@/components/Form/Form';
import VInput from '@/components/Form/Input';
import { focusFirstError } from '@/utils/form';
import Proxy from '@/proxies/AuthProxy';
import { AUTH, HOME } from '@route-types';
import VSvgIcon from '@/components/UI/VSvgIcon.vue';
const BASE = process.env.BASE_URL || '/';
export default {
  name: 'AuthIdentification',

  components: {
    VSvgIcon,
    VSpinner,
    VForm,
    VInput,
    VProgress: () => import('@/components/Progress'),
    VButton: () => import('@/components/Button'),
  },

  mixins: [TitleMixin, AuthStepsMixin, OtpResendMixin],

  data() {
    return {
      proxy: new Proxy(),
    };
  },

  created() {
    if (!this.$route.params.msisdn) {
      this.$router.replace({ name: AUTH }); // when hitting f5, or directly accessing this page, route to entrance page!
    } else {
      this.$webtrekk.viewPage('authsite.onetimepin.verification', 'authentication.common');
    }
  },

  methods: {
    async onNext({ values, form }) {
      try {
        this.isBusy = true;
        const response = await this.proxy.otpVerify(values);
        if (response.isRedirect) {
          window.location.href = response.redirectUrl;
        } else {
          await this.$store.dispatch('contract/set', { contractHash: response.contractHash });
          await this.$store.dispatch('system/init');
          this.$router.push({ name: HOME });
        }
        // TODO: either redirect or reload init
      } catch (error) {
        const code = error?.data?.code;
        if (code === 'WRONG_OTP') {
          form.otp.setInvalid();
        } else {
          throw error;
        }
        focusFirstError(form);
        this.isBusy = false;
      }
    },
  },
};
</script>
